import { render } from "./B2bPageCentres.vue?vue&type=template&id=22a309c3&scoped=true&lang=pug"
import script from "./B2bPageCentres.vue?vue&type=script&lang=js"
export * from "./B2bPageCentres.vue?vue&type=script&lang=js"

import "./B2bPageCentres.vue?vue&type=style&index=0&id=22a309c3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a309c3"]])

export default __exports__